import type { RewardVisual } from './reward-visuals'

/**
 * The `status` input of reward.riv's `reward_reveal` state machine (shared
 * with the focus-pass reward flow): it selects the background reveal
 * animation variant — coins = 1, gems = 2, everything else = 3.
 */
export type RevealStatus = 1 | 2 | 3

export function revealStatus(visual: RewardVisual): RevealStatus {
  switch (visual.kind) {
    case 'coins':
      return 1
    case 'gems':
      return 2
    case 'content':
      return 3
  }
}

/** A coin/gem balance credit, shaped like the balances it applies to. */
export interface CurrencyDelta {
  coin: number
  gem: number
}

/**
 * The balance credit a claimed reward applies to the coin/gem pills — the
 * local mirror of what the backend delivery grants (see CONTEXT.md "Reward
 * reveal": the reveal only presents an already-delivered reward).
 */
export function currencyDelta(visual: RewardVisual): CurrencyDelta {
  switch (visual.kind) {
    case 'coins':
      return { coin: visual.amount, gem: 0 }
    case 'gems':
      return { coin: 0, gem: visual.amount }
    case 'content':
      return { coin: 0, gem: 0 }
  }
}
